import { CKButton } from 'clearkit';

import { ButtonContainer } from '~/components/unified/ButtonContainer';

import { ProspectorFilters } from './ProspectorFilters';
import { ProspectorSidebar } from './ProspectorSidebar';

export const SidebarNewList = () => (
  <ProspectorSidebar>
    <ProspectorSidebar.Breadcrumbs>
      New Prospect List
    </ProspectorSidebar.Breadcrumbs>
    <ProspectorFilters />
    <ProspectorSidebar.Footer>
      <ButtonContainer>
        <CKButton>Discard</CKButton>
        <CKButton variant="bold" variantColor="blue">
          Save List
        </CKButton>
      </ButtonContainer>
    </ProspectorSidebar.Footer>
  </ProspectorSidebar>
);
